'use strict';

(function() { // jshint ignore:line

    angular.module('itxApp.common').factory('itxAkamaiSvc', ['$q', 'AkamaiDateSvc', function($q, AkamaiDateSvc) {

        function _useAkamaiProductImage(url, width){
            if(url.match(/\&impolicy/)){
                return;
            }
            function replacer(match, p1) {
                // p1 is nondigits, p2 digits, and p3 non-alphanumerics
                return '_16.'+p1;
            }
            url = url.replace(/_[0-9]{1,2}\.(jpg|png|gif)/,replacer);
            return _useAkamaiImage(url, width);
        }

        //Receives an url with jpg 
        //@param width  the real size of the scaled picture
        function _useAkamaiImage(url, width){

            var multiplier;
            if(window.devicePixelRatio >=2){
                multiplier = 1.7;
            }
            else{
                multiplier = window.devicePixelRatio;
            }
            
            width = width*multiplier;
            width =  Math.ceil(width /100);
            width = width*100;

            var quality = 'medium';
            // if(ItxScreenSizeSvc.is('md,lg')){
            //     quality = 'mediumhigh';
            // }
            url = url + '&impolicy=massimodutti-itx'+quality + '&imwidth='+(width);
            return url;
        }
        

        return {
            useAkamaiImage: _useAkamaiImage,
            useAkamaiProductImage:_useAkamaiProductImage,
            
            //DEPRECATED FUNCTIONS. Se deberian usar directamente las del servicio AkamaiDateSvc
            getDate: AkamaiDateSvc.getDate,
            getForcedCurrentDate: AkamaiDateSvc.getForcedCurrentDate,
            transformUtcToLocal: AkamaiDateSvc.transformUtcToLocal,
            getLocalStringFromMoment: AkamaiDateSvc.getLocalStringFromMoment
        };
    }]);

})();